import { createIcon } from '../createIcon';

export const HandPeaceIconConfig = {
  name: 'HandPeaceIcon',
  height: 512,
  width: 448,
  svgPath: 'M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const HandPeaceIcon = createIcon(HandPeaceIconConfig);

export default HandPeaceIcon;